import React from "react";
import { europeanDestinations } from "../components/DestinationsSection";
import "./DestinationPages.css";

const EuropeDestinations = () => {
  return (
    <div className="dest-page">
      <h2>Featured Destinations Across Europe</h2>
      <div className="dest-grid">
        {europeanDestinations.map((place) => (
          <div key={place.id} className="dest-card">
            <img src={place.images[0]} alt={place.title} />
            <h3>{place.title}</h3>
            
          </div>
        ))}
      </div>
    </div>
  );
};

export default EuropeDestinations;
